import { css } from 'linaria';

export const kitchenUtpSectionModalContent = css`
  padding-bottom: 40px;

  @media (--only-mobile) {
    padding-bottom: 32px;
  }
`;

export const kitchenUtpSectionModalText = css`
  margin-bottom: 8px;
`;

export const kitchenUtpSectionModalList = css`
  && {
    li:not(:last-child) {
      margin-bottom: 4px;
    }
  }
`;
